module.exports = __webpack_public_path__ + "img/100.6.b0734a7a.png";